import { render, staticRenderFns } from "./customerPassRatioPage.vue?vue&type=template&id=d4974cb8&scoped=true&"
import script from "./customerPassRatioPage.vue?vue&type=script&lang=js&"
export * from "./customerPassRatioPage.vue?vue&type=script&lang=js&"
import style0 from "./customerPassRatioPage.vue?vue&type=style&index=0&id=d4974cb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4974cb8",
  null
  
)

export default component.exports